import React from 'react'

import '../CSS/OurProcess2.css'

const OurProcess2 = () => {
  return (
    <div className='ourprocess2wrap'>
        <div className='ourprocessheadingwrap'>
            <h2>OUR PROCESS</h2>
            
            <p>We provide professional, complete and fast-track access to world-class and career oriented education to foster development.</p>
        <div className='line1'></div>
        </div>
        <div className='stepswrap'>
        <div className='step1heading'>
            <div className='step1headingleft'>
                <h2>
                    Send Us Your Documents
                </h2>

            </div>
            <div className='step1headingright'>
                <div className='circle1'></div>
                <div className='title1'>STEP #1</div>
            </div>

        </div>
        <div className='step1body'>
            <div className='step1bodyleft'>
                <p>Document required to make the application on your behalf</p>
                <p>Academic Qualification, CV, Passport, Personal Statement, Any other supporting document that you think would be useful for your application.</p>
                <p>
                We will review the documents that you have sent us and advise on any improvement to maximise the chances of successful offers. We can apply to multiple universities on your behalf.</p>
            </div>
            <div className='step1bodyright'>
            <div className='step1headingleft2'>
                <h2>
                    Send Us Your Documents
                </h2>

            </div>
                <p>Document required to make the application on your behalf</p>
                <p>Academic Qualification, CV, Passport, Personal Statement, Any other supporting document that you think would be useful for your application.</p>
                <p>
                We will review the documents that you have sent us and advise on any improvement to maximise the chances of successful offers. We can apply to multiple universities on your behalf.</p>
            </div>

        </div>
        </div>

        <div className='stepswrap'>
        <div className='step1heading'>
            <div className='step1headingleft'>
                <h2>
                Accept An Admission Offer
                </h2>

            </div>
            <div className='step1headingright'>
                <div className='circle1'></div>
                <div className='title1'>STEP #2</div>
            </div>

        </div>
        <div className='step1body'>
            <div className='step1bodyleft'>
                <p>We will advise and assist you in choosing the most suitable offer and meeting any conditions of these offers to get you to the next step of the process.</p>
               
            </div>
            <div className='step1bodyright'>
            <div className='step1headingleft2'>
                <h2>
                Accept An Admission Offer
                </h2>

            </div>
            <p>We will advise and assist you in choosing the most suitable offer and meeting any conditions of these offers to get you to the next step of the process.</p>
            </div>

        </div>
        </div>





        <div className='stepswrap'>
        <div className='step1heading'>
            <div className='step1headingleft'>
                <h2>
                Make Payment For Your Fees
                </h2>

            </div>
            <div className='step1headingright'>
                <div className='circle1'></div>
                <div className='title1'>STEP #3</div>
            </div>

        </div>
        <div className='step1body'>
            <div className='step1bodyleft'>
                <p>We streamline the payment process to enable you make deposits in due time. Once your payment has been wired into the university’s bank account, we will assist you with the provision of required maintenance documents and undergo a satisfactory interview by the university Compliance Team.</p>
               
            </div>
            <div className='step1bodyright'>
            <div className='step1headingleft2'>
                <h2>
                Make Payment For Your Fees
                </h2>

            </div>
            <p>We streamline the payment process to enable you make deposits in due time. Once your payment has been wired into the university’s bank account, we will assist you with the provision of required maintenance documents and undergo a satisfactory interview by the university Compliance Team.</p>
            </div>

        </div>
        </div>




        
        <div className='stepswrap'>
        <div className='step1heading' >
            <div className='step1headingleft'>
                <h2>
                Start Your Visa Application
                </h2>

            </div>
            <div className='step1headingright'>
                <div className='circle1'></div>
                <div className='title1'>STEP #4</div>
            </div>

        </div>
        <div className='step1body'>
            <div className='step1bodyleft'>
                <p>All international students need a visa to study abroad. Please note that if you’re coming from the European Union or European Economic Association (EEA) countries, you won’t need a visa for the destinations within. These universities will issue the necessary documentation to assist students in obtaining entry clearance to the study destination.</p>
               
            </div>
            <div className='step1bodyright'>
            <div className='step1headingleft2'>
                <h2>
                Start Your Visa Application
                </h2>

            </div>
            <p>All international students need a visa to study abroad. Please note that if you’re coming from the European Union or European Economic Association (EEA) countries, you won’t need a visa for the destinations within. These universities will issue the necessary documentation to assist students in obtaining entry clearance to the study destination.</p>
            </div>

        </div>
        </div>




        <div className='stepswrap'>
        <div className='step1heading'>
            <div className='step1headingleft'>
                <h2>
                Arrive In Your Dream University
                </h2>

            </div>
            <div className='step1headingright'>
                <div className='circle1'></div>
                <div className='title1'>STEP #5</div>
            </div>

        </div>
        <div className='step1body'>
            <div className='step1bodyleft'>
                <p>We streamline the payment process to enable you make deposits in due time. Once your payment has been wired into the university’s bank account, we will assist you with the provision of required maintenance documents and undergo a satisfactory interview by the university Compliance Team.</p>
               
            </div>
            <div className='step1bodyright'>
            <div className='step1headingleft2'>
                <h2>
                Arrive In Your Dream University
                </h2>

            </div>
            <p>We streamline the payment process to enable you make deposits in due time. Once your payment has been wired into the university’s bank account, we will assist you with the provision of required maintenance documents and undergo a satisfactory interview by the university Compliance Team.</p>
            </div>

        </div>
        </div>




       
       
    </div>
  )
}

export default OurProcess2
